import moment from 'moment';

import { axiosDelete, axiosGet, axiosPatch, axiosPost } from './axios.helpers';

export const getAppointments = async (day, clinicId, monthDate) => {
  const start = moment(monthDate).startOf('month').format('YYYY-MM-DD');
  const end = moment(monthDate).endOf('month').format('YYYY-MM-DD');
  const clinicSuffix = clinicId ? `&filter[clinic]=${clinicId}` : '';

  const date = moment(day).format('YYYY-MM-DD');

  const dateRangeSuffix = day
    ? `&filter[from]=${date}&filter[to]=${date}`
    : `&filter[from]=${start}&filter[to]=${end}`;

  return axiosGet(
    `/appointments?page[size]=10000&page[number]=1&include=service,clinic,participant${dateRangeSuffix}${clinicSuffix}`,
  );
};

export const getAppointmentsByClinicId = async (date, clinicId) => {
  const clinicSuffix = clinicId ? `&filter[clinic]=${clinicId}` : '';

  const startDate = moment(date).format('YYYY-MM-DD');
  const endDate = moment(date).add(1, 'days').format('YYYY-MM-DD');

  const dateRangeSuffix = `&filter[from]=${startDate}&filter[to]=${endDate}`;

  return axiosGet(
    `/appointments?page[size]=10000&page[number]=1&include=service,clinic,participant${dateRangeSuffix}${clinicSuffix}`,
  );
};

export const getAppointmentsByUuid = async (uuid) =>
  axiosGet(
    `/appointments/${uuid}?include=clinic,participant,organization,sublocation,service`,
  );

export const showAppointment = async (id) => axiosGet(`/appointments/${id}`);

export const createAppointment = async (participant, appointment) => {
  await axiosPost('/appointments', {
    participant,
    appointment,
  });
};

export const deleteAppointment = async (id) => {
  await axiosDelete(`/appointments/${id}`);
};
